export default "__VITE_ASSET__B0ESXw8c__"